import * as types from 'actions/constants/ActionTypes';
import {consolidateState} from 'components/Utils';
import subNodeForm from './subNodeForm';
import {nodeFormActions} from 'actions/arr/subNodeForm';
import { serializeJson } from 'components/arr/FundDataGrid';

const initialState = {
    initialised: false, // jestli byl prvotně inicializován, např. seznam zobrazovaných sloupců atp.
    isFetchingFilter: false,
    fetchedFilter: false,
    isFetchingData: false,
    fetchedData: false,
    rowsDirty: false, // zda jsou data tabulky již neaktuální - počet řádek na serveru již nemusí odpovídat řádkům na klientovi - např. byla přidána nová JP
    filterDirty: false, // pokud nastala od poskledního přefiltrování nějaká změna v hodnotách PP - výsledek filtru již nemusí odpovídat tomu, co se zobrazuje
    items: [],
    itemsCount: 0,
    filter: {}, // mapa id desc item type na filter data
    visibleColumns: {}, // seznam mapa id na boolean viditelných sloupečků   // "4", "5", "8", "9", "11", "14", "17", "38", "42", "44", "50", "53"
    columnsOrder: [], // seznam id desc item type - pořadí zobrazování sloupečků
    columnInfos: {}, // mapa id desc item type na informace o sloupečku, např. jeho šířce atp.
    currentDataKey: '',
    subNodeForm: subNodeForm(),
    nodeId: null, // id node právě editovaného řádku
    parentNodeId: null, // id parent node právě editovaného řádku
    descItemTypeId: null, // id atributu právě editovaného řádku
    searchText: '',
    searchExtended: false,
    luceneQuery: false,
    data: {type: 'FORM'},
    showFilterResult: false,
    searchedItems: [], // výsledky hledání dat
    searchedCurrentIndex: 0, // index aktuálně vybrané položky ve výsledcích hledání
};
// new Array("4", "5", "8", "9", "11", "14", "17", "38", "42", "44", "50", "53").forEach(a => {
//     initialState.visibleColumns[a] = true
// });

function changeSearchedIndex(state, newIndex) {
    // Move the cursor within the search results; the page/row jump is driven by the component via the view context.
    return {
        ...state,
        searchedCurrentIndex: state.searchedItems.length === 0 ? 0 : newIndex,
    };
}

export default function fundDataGrid(state = initialState, action = {}) {
    if (nodeFormActions.isSubNodeFormAction(action)) {
        const result = {
            ...state,
            subNodeForm: subNodeForm(state.subNodeForm, action),
        };
        return consolidateState(state, result);
    }

    switch (action.type) {
        case types.STORE_LOAD:
            return {
                ...initialState,
                ...state,
                isFetchingFilter: false,
                fetchedFilter: false,
                isFetchingData: false,
                fetchedData: false,
                items: [],
                itemsCount: 0,
                currentDataKey: '',
                subNodeForm: subNodeForm(),
                searchedItems: [],
                searchedCurrentIndex: 0,
                data: {type: 'FORM'},
            };
        case types.STORE_SAVE: {
            // The view state (page, selection, focus) is held by the context in localStorage, not Redux.
            const {initialised, filter, visibleColumns, columnsOrder, columnInfos, serializedFilter} = state;

            return {
                initialised,
                filter,
                serializedFilter,
                visibleColumns,
                columnsOrder,
                columnInfos,
            };
        }
        case types.FUND_FUND_DATA_GRID_INIT: {
            let visibleColumns = {};
            let columnInfos = {};

            // Pokud visible column již jsou, nechají se, jinak se inicializují z akce, kde jsou implcitní nastavené v pravidlech
            if (state.visibleColumns && Object.keys(state.visibleColumns) > 0) {
                // je definovaný
                visibleColumns = state.visibleColumns;
            } else {
                // není definováno, vezmeme z nastavení v pravidlech
                visibleColumns = {};
                action.initData.visibleColumns.forEach(id => {
                    visibleColumns[id] = true;
                });
            }

            // Pokud je informace o sloupcích již jsou, nechají se, jinak se inicializují z akce, kde jsou nastavené v pravidlech
            if (state.columnInfos && Object.keys(state.columnInfos) > 0) {
                // je definovaný
                columnInfos = state.columnInfos;
            } else {
                // není definováno, vezmeme z nastavení v pravidlech
                columnInfos = action.initData.columnInfos || {};
            }

            // ---

            return {
                ...state,
                initialised: true,
                visibleColumns,
                columnInfos,
                currentDataKey: '',
                isFetchingFilter: false,
                fetchedFilter: false,
                isFetchingData: false,
                fetchedData: false,
            };
        }
        case types.FUND_FUND_DATA_GRID_FULLTEXT_NEXT_ITEM:
            return changeSearchedIndex(state, state.searchedCurrentIndex + 1);
        case types.FUND_FUND_DATA_GRID_FULLTEXT_PREV_ITEM: {
            return changeSearchedIndex(state, state.searchedCurrentIndex - 1);
        }
        case types.FUND_FUND_DATA_GRID_FULLTEXT_EXTENDED:
            return {
                ...state,
                searchText: '',
                showFilterResult: false,
                searchExtended: !state.searchExtended,
            };
        case types.FUND_FUND_DATA_GRID_FULLTEXT_CLEAR:
            return {
                ...state,
                showFilterResult: false,
            };
        case types.FUND_FUND_DATA_GRID_FULLTEXT_RESULT:
            const midState = {
                ...state,
                searchedItems: action.searchedItems,
                searchText: action.filterText,
                showFilterResult: action.filterText !== '' || action.luceneQuery,
                luceneQuery: action.luceneQuery,
                data: action.data,
            };
            return changeSearchedIndex(midState, 0);
        case types.FUND_FUND_DATA_GRID_FILTER_CLEAR_ALL:
            return {
                ...state,
                filter: {},
                serializedFilter: undefined,
                fetchedFilter: false,
                isFetchingFilter: false,
            };
        case types.FUND_FUND_DATA_GRID_PREPARE_EDIT:
            const result = {
                ...state,
                nodeId: action.nodeId,
                parentNodeId: action.parentNodeId,
                descItemTypeId: action.descItemTypeId,
            };

            if (action.nodeId !== state.subNodeForm.fetchingId) {
                result.subNodeForm = subNodeForm();
            }

            return result;
        case types.FUND_FUND_DATA_GRID_COLUMNS_SETTINGS:
            return {
                ...state,
                visibleColumns: action.visibleColumns,
                columnsOrder: action.columnsOrder,
            };
        case types.FUND_FUND_DATA_GRID_COLUMN_SIZE:
            let columnInfos = {...state.columnInfos};
            const info = columnInfos[action.columnId] || {};
            info.width = action.width;
            columnInfos[action.columnId] = info;
            return {
                ...state,
                columnInfos: columnInfos,
            };
        case types.FUND_FUND_DATA_GRID_FILTER_CHANGE:
            return {
                ...state,
                filter: action.filter,
                serializedFilter: action.filter
                    && Object.keys(action.filter).length > 0
                    ? serializeJson(action.filter) : undefined ,
                fetchedFilter: false,
            };
        case types.FUND_FUND_DATA_GRID_FILTER_REQUEST:
            return {
                ...state,
                isFetchingFilter: true,
            };
        case types.FUND_FUND_DATA_GRID_FILTER_RECEIVE:
            // The view state (page reset, focus clamp) is handled by the component via the context, based on resetViewState and itemsCount.
            return {
                ...state,
                rowsDirty: false,
                filterDirty: false,
                isFetchingFilter: false,
                fetchedFilter: true,
                itemsCount: action.itemsCount,
                currentDataKey: '', // vynucení načtení dat!!!
            };
        case types.CHANGE_ADD_LEVEL:
        case types.CHANGE_DELETE_LEVEL:
        case types.CHANGE_MOVE_LEVEL: {
            return {
                ...state,
                rowsDirty: true,
            };
        }
        case types.FUND_NODE_INCREASE_VERSION:
            return {
                ...state,
                subNodeForm: subNodeForm(state.subNodeForm, action),
            };
        case types.FUND_SUBNODE_UPDATE:
        case types.CHANGE_NODES:
            return {
                ...state,
                filterDirty: true, // filtr po změně nějakého PP již nemusí odpovídat
                currentDataKey: '',
                subNodeForm: subNodeForm(state.subNodeForm, action),
            };
        case types.FUND_FUND_DATA_GRID_DATA_REQUEST:
            return {
                ...state,
                isFetchingData: true,
                currentDataKey: action.dataKey,
            };
        case types.FUND_FUND_DATA_GRID_DATA_RECEIVE:
            // The component prunes the context's selectedIds to the current page's rows after this.
            return {
                ...state,
                isFetchingData: false,
                fetchedData: true,
                items: action.items,
            };
        case types.FUND_FUND_DATA_GRID_DATA_ERROR:
            // Clear the data key so the same page can be requested again after a failed fetch.
            return {
                ...state,
                isFetchingData: false,
                currentDataKey: '',
            };
        default:
            return state;
    }
}
